import React from "react";
import classnames from "classnames";

type DropdownItemProps = {
    className: string;
    onClick: () => void;
    label: string;
    disabled?: boolean;
};

export default function DropdownItem({
    className,
    onClick,
    label,
    disabled,
}: DropdownItemProps) {
    return (
        <div
            className={classnames(
                `dropdown-item pl-1 pointer__clz ${className}`,
                {
                    "not-allowed-icon__clz": disabled,
                }
            )}
            style={{ cursor: "pointer" }}
            onClick={disabled ? undefined : onClick}
        >
            <span className="ml-2">{label}</span>
        </div>
    );
}
